import React from "react";
import "../../Assets/SCSS/components/Label.scss";

const IconLabel = ({ labelClassNames, img, label, className, iconHeight }) => (
  <div className={`display-flex ${className}`} style={{ alignItems: "center" }}>
    <img
      src={img}
      alt="icon"
      height={iconHeight ? iconHeight : 16}
      className="vertical-middle"
    />

    <span
      className={`extra-small-dark-secondary margin-left-8 ${labelClassNames}`}
    >
      {label}
    </span>
  </div>
);

export default IconLabel;
